import { createAction } from 'redux-actions';

export const add = createAction(
  'WISH_LIST/ADD',
  (listingId) => ({
    listingId,
  }),
  () => ({ auth: { needsToken: true } })
);
export const remove = createAction(
  'WISH_LIST/REMOVE',
  (listingId) => ({
    listingId,
  }),
  () => ({ auth: { needsToken: true } })
);
export const updateSuccess = createAction(
  'WISH_LIST/UPDATE_SUCCESS',
  (entries) => ({
    entries,
  })
);

export default {
  add,
  remove,
  updateSuccess,
};
